import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { config } from 'app/shared/smartadmin.config';
import {JsonApiService} from '../../core/api/json-api.service';
import { Subject } from 'rxjs/Subject';
import { HubConnection, HubConnectionBuilder } from '@aspnet/signalr';
import { ChatMensaje, ChatUsuario } from 'app/core/model/classes/chat';
import { CurrentUser } from 'app/core/model/trjireh-model';
import { ChatMessage } from 'app/core/model/classes/chatMessage';

@Injectable()
export class ChatService implements OnInit {

  url: string;
  chatURL: string = config.API_DATA_URL + '/chat';

  public messageToSubject;
  public newMessage;
  public chatMessage;
  public sessionClosed;
  public messageSended;
  public statusChanged;

  currentUser: CurrentUser = new CurrentUser();

  public hubConnection: HubConnection;

  constructor(
    private jsonApiService: JsonApiService,
    public http: HttpClient) {
    this.url = '/chat/chat.json';
    this.messageToSubject = new Subject();
    this.newMessage = new Subject();
    this.chatMessage = new Subject();
    this.messageSended = new Subject();
    this.statusChanged = new Subject();
    this.sessionClosed = new Subject();

    // subscripcion a Received
    // this.hubConnection.on('Received', (mensaje) => {
    //   this.RecibirMensaje(mensaje);
    // });

    // // Subscripcion a StatusChanged
    // this.hubConnection.on('StatusChanged', (mensaje) => {
    //   // console.log('StatusChanged', mensaje);
    //   this.NotificarStatus(mensaje);
    // });

  //   this.hubConnection.start()
  //     .then(() => {
  //       console.log('Conexion establecida');
  //       this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
  //       const usuario = {
  //         nombre: this.currentUser.nombre,
  //         usuario: this.currentUser.claveUsuario,
  //         status: 'ON'
  //       };
  //       this.hubConnection.invoke('NotificarStatus', usuario);
  //     })
  //     .catch(err => console.error(err.toString()));
   }

  ngOnInit(): void {
    // console.log('OnOnit');
    // this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    // console.log('Init: ', this.currentUser);
  }

  Logueado() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser != null && currentUser != undefined) {
      const mensaje = new ChatMessage();
      mensaje.fromUsuario = currentUser.claveUsuario;
      mensaje.toUsuario = '';
      mensaje.mensaje = '';
      mensaje.tipo = 'I';
      this.EnviarMensaje(mensaje);
    }
    // console.log('Logueado enviado ', mensaje);
    // const builder = new HubConnectionBuilder();
    // this.hubConnection = builder.withUrl(config.CHAT_URL).build();

    // this.hubConnection.on('Received', (mensaje) => {
    //   this.RecibirMensaje(mensaje);
    // });

    // // Subscripcion a StatusChanged
    // this.hubConnection.on('StatusChanged', (mensaje) => {
    //   // console.log('StatusChanged', mensaje);
    //   this.NotificarStatus(mensaje);
    // });

    // this.hubConnection.start()
    //   .then(() => {
    //     this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    //     const usuario = {
    //       nombre: this.currentUser.nombre,
    //       usuario: this.currentUser.claveUsuario,
    //       status: 'ON'
    //     };
    //     this.hubConnection.invoke('NotificarStatus', usuario);
    //     console.log('Conexion establecida 1');
    //   })
    //   .catch(err => console.error(err.toString()));
  // }
    // console.log('Logueado ', this.hubConnection.state);
    // if (this.hubConnection.state == 1) {
    //   const usuario = {
    //     nombre: this.currentUser.nombre,
    //     usuario: this.currentUser.claveUsuario,
    //     status: 'ON'
    //   };
    //   this.hubConnection.invoke('NotificarStatus', usuario);
    // }
  }

  stop() {
    console.log('voy a Cerrar sesion');
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    const mensaje = new ChatMessage();
    mensaje.fromUsuario = currentUser.claveUsuario;
    mensaje.toUsuario = '';
    mensaje.mensaje = '';
    mensaje.tipo = 'O';
    this.EnviarMensaje(mensaje);
    // console.log('Cerrando sesion');
    // if (this.hubConnection && this.hubConnection.state == 1) {

    //   const usuario = {
    //     nombre: this.currentUser.nombre,
    //     usuario: this.currentUser.claveUsuario,
    //     status: 'OFF'
    //   };

    //   this.hubConnection.invoke('NotificarStatus', usuario).then(() => {
    //     this.hubConnection.stop()
    //     .catch(err => console.error(err.toString()));
    //   });
    // }
    // this.sessionClosed.next();
    // console.log('Sesion terminada');
  }

  NotificarStatus(usuario: ChatUsuario) {
    // if (this.currentUser.claveUsuario != usuario.usuario) {
    //   this.statusChanged.next(usuario);
    // }
  }

  RecibirMensaje(mensaje: ChatMensaje) {
    // console.log('current: ', this.currentUser);
    // if (this.currentUser.claveUsuario == mensaje.toUsuario) {
    //   this.chatMessage.next(mensaje);
    // } else {
    //   console.log(mensaje);
    // }
  }

  getChatState()  {
    return this.jsonApiService.fetch(this.url)

  }

  messageTo(user) {
    this.messageToSubject.next(user)
  }

  sendMessage(message) {
    this.newMessage.next(message)

  }

  public sendChatMessage(message: string) {
    console.log('Enviando');
    this.hubConnection.invoke('Echo', message);
    console.log('Listo');
  }

  /*************************************
   * Leer los usuarios para el Chat
   *************************************/
  public GetChatUsuarios(): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.chatURL + '/GetChatUsuarios', { headers })
    .map( (response: any) => {
        return response;
      })
    .catch(this.handleError)
  }

  /***************************************
   *  ENvia el mensaje para chatear
  *****************************************/
  public EnviarMensaje(mensaje: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(mensaje);
    return this.http.post(this.chatURL + '/EnviarMensaje', param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  private getBaseUrl() {
    return location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + '/'
  }

  private getHeaders(): HttpHeaders {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return headers;
  }

  private handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    const errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error(errMsg); // log to console instead
    return Observable.throw(errMsg);
  }

}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/shared/chat/chat.service.ts